import React from 'react'
import PropTypes from 'prop-types'
import styles from '../../scss/ui/card.scss'

const Card = ({ children, title, bodyWidth }) => (
    <div className={styles.card}>
        <h2>{title}</h2>
        <div className={styles[bodyWidth]}>
            {children}
        </div>
    </div>
)

Card.defaultProps = {
    bodyWidth: 'cardBody',
}

Card.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    bodyWidth: PropTypes.oneOf(['cardBody', 'cardBodyNarrow']),
}

export default Card



// WEBPACK FOOTER //
// ./src/ui/CarouselCards/Card.js